import { useMutation } from "@tanstack/react-query";
import { toast } from "sonner";
import axiosAuth from "../../axiosAuth";
import { CREATE_INVENTORY_STATUS } from "../apiRoutes";
import { removeEmptyFields } from "@/lib/utils";

export interface InventoryStatusItem {
  packingStatus: string;
  approvedBy: string;
  shipmentDate: string;
  inventoryCheckLists: Array<string>;
}

export interface CreateInventoryStatusPayload {
  schoolId: string;
  inventoryStatusList: InventoryStatusItem[];
  note?: string | null;
}

export interface CreateInventoryStatusResponse {
  status?: number;
  error?: boolean;
  message?: string;
  data?: any;
}

export const useCreateInventoryStatus = (options?: { onSuccess?: () => void }) => {
  return useMutation({
    mutationFn: async (payload: CreateInventoryStatusPayload) => {
      const response = await axiosAuth.post<CreateInventoryStatusResponse>(
        CREATE_INVENTORY_STATUS,
        removeEmptyFields(payload)
      );
      return response.data;
    },
    onSuccess: () => {
      toast.success("Inventory Status Created successfully");
      options?.onSuccess?.();
    },
    onError: (error: any) => {
      const message =
        error?.response?.data?.issues?.message || 
        error?.response?.data?.message || 
        "Failed to save inventory details";
      toast.error(message);
    },
  });
};